/**
 * SS Team Reducers
 */
import {
    ALL_SSTEAMS,
    ADD_SSTEAM,
    SSTEAM_ACTION,
    EDIT_SSTEAM,
    STATUS_SSTEAM,
    DELETE_SSTEAM
} from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
    ssteamlists:[],
    loading: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case SSTEAM_ACTION:
            return { ...state, loading: true };

        case ALL_SSTEAMS:
            return { ...state, loading: false, ssteamlists: action.payload };  
            
        case ADD_SSTEAM:
            return { ...state, loading: false }; 
        
        case EDIT_SSTEAM:
            return { ...state, loading: false };  
        
        case STATUS_SSTEAM:
            return { ...state, loading: false };    
        
        case DELETE_SSTEAM:
            return { ...state, loading: false };      

        default: return { ...state };
    }
}